import { zSidLabel } from "src/types";
import z from "zod";

// Внутреннее представление классификации на форме
// classifierId => SidLabel[]

export const zClassificationInternal = z.record(
  z.string().describe("classifierId"),
  zSidLabel.array().nullish(),
);
export type ZClassificationInternal = z.infer<typeof zClassificationInternal>;
